export default "__VITE_ASSET__378e8e71__"